import { useCallback, useMemo, useState } from "react";
import type { Artwork } from "../types";

export function useLightbox(list: Artwork[]) {
  const [activeId, setActiveId] = useState<string | null>(null);

  const index = useMemo(() => list.findIndex((a) => a.id === activeId), [list, activeId]);
  const active = index >= 0 ? list[index] : null;

  const open = useCallback((a: Artwork) => setActiveId(a.id), []);
  const close = useCallback(() => setActiveId(null), []);
  const prev = useCallback(() => {
    if (index > 0) setActiveId(list[index - 1].id);
  }, [index, list]);
  const next = useCallback(() => {
    if (index >= 0 && index < list.length - 1) setActiveId(list[index + 1].id);
  }, [index, list]);

  return {
    active,
    open,
    close,
    prev: index > 0 ? prev : undefined,
    next: index >= 0 && index < list.length - 1 ? next : undefined,
  };
}
